import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { clusterById } from '../../../data/teaser';
import { proactive, proactivePlans, snak2Images } from '../../../data/snak2';
const EASE = [0.23, 1, 0.32, 1] as const;
export function ProactiveScreen() {
  const [index, setIndex] = useState(0);
  const plan = proactivePlans[index];
  const cluster = clusterById(plan.clusterId);
  const rows = [{
    label: proactive.watchLabel,
    value: plan.watch
  }, {
    label: proactive.intervalLabel,
    value: plan.interval
  }, {
    label: proactive.triggerLabel,
    value: plan.trigger
  }];
  return <div className="flex flex-1 flex-col" data-id="element-341" data-mp="267gvgsx5e1ds">
      <div className="flex items-start gap-3" data-id="element-342" data-mp="268iilvrfuebv">
        <motion.h2 initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        ease: EASE
      }} className="flex-1 font-display text-[24px] font-bold uppercase leading-[1] tracking-tight text-ozNavy" data-id="element-343" data-mp="2b5s6v833cjy4">
          {proactive.headline[0]}
          <span className="mt-1 block text-ozBlue" data-id="element-344" data-mp="34zum24vkhh24">{proactive.headline[1]}</span>
        </motion.h2>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.28,
        delay: 0.08,
        ease: EASE
      }} src={snak2Images.fundus.src} alt={snak2Images.fundus.alt} draggable={false} className="h-[62px] w-[62px] shrink-0 select-none rounded-full border-2 border-paper object-cover shadow-soft" data-id="element-345" data-mp="2zz6xrqyq3ebl" />
      </div>

      <p className="mt-3 text-[12px] leading-relaxed text-mut" data-id="element-346" data-mp="3isj6navjd8kk">{proactive.lead}</p>

      <div className="mt-4 flex gap-1.5" role="tablist" aria-label="Phenotype clusters" data-id="element-347" data-mp="3dy6m0xibpr78">
        {proactivePlans.map((p, i) => {
        const isActive = i === index;
        return <button key={p.clusterId} type="button" role="tab" aria-selected={isActive} onClick={() => setIndex(i)} className={`h-9 flex-1 rounded-lg border font-display text-[12px] font-bold tracking-tight transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-ozBlue ${isActive ? 'border-ozNavy bg-ozNavy text-paper' : 'border-line bg-ozMist text-ozNavy hover:border-ozBlue'}`} data-id="element-348" data-mp="achd94530rsb" data-mpi={i}>
              CL {i + 1}
            </button>;
      })}
      </div>

      <AnimatePresence mode="wait" data-id="element-349" data-mp="1m152zd9udqnz">
        <motion.div key={plan.clusterId} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} className="mt-3" data-id="element-350" data-mp="1lyakvseawhxq">
          <p className="text-[11px] leading-snug text-ozBlue" data-id="element-351" data-mp="31i6xqk9r12yc">{cluster.descriptor}</p>
          <p className="mt-1 text-[10.5px] leading-snug text-mut" data-id="element-352" data-mp="36ggsitrka1jf">{cluster.signature}</p>

          <dl className="mt-3 flex flex-col gap-2" data-id="element-353" data-mp="usbzzgttkqbh">
            {rows.map((row, i) => <motion.div key={row.label} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.22,
            delay: 0.05 + i * 0.05,
            ease: EASE
          }} className="border-l-2 border-ozGreen pl-3" data-id="element-354" data-mp="pu2391sg5hnr" data-mpi={i}>
                <dt className="text-[8.5px] uppercase tracking-micro text-mut" data-id="element-355" data-mp="1ditkwz8euhma">{row.label}</dt>
                <dd className="mt-0.5 text-[12.5px] font-medium leading-snug text-ozNavy" data-id="element-356" data-mp="19iavfbtzpnn9">
                  {row.value}
                </dd>
              </motion.div>)}
          </dl>
        </motion.div>
      </AnimatePresence>

      <p className="mt-auto pt-4 text-[9.5px] leading-snug text-mut" data-id="element-357" data-mp="1iiz7i0ztpdxi">{proactive.caveat}</p>
    </div>;
}